<template>
    <div style="background-color: #fafafa;">
        <van-nav-bar :title="detailTitle" :left-text="backTitle" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
        <div class="skuDetailDiv">
            <grid class="form-box" v-model="data" :descriptions="descriptions"/>
        </div>
        <div class="recordBox">
            <van-button type="info" size="large" @click="save">加入购物车</van-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Tab, Tabs, Panel, Field, List,Search, Popup, PullRefresh, NavBar, Button,Toast} from 'vant';
    import dealerOrderService from "../../service/dealerOrderService";
    import Grid from "../../components/Grid";
    import moment from "moment";

    export default {
        data: function () {
            return {
                detailTitle: "产品详情",
                backTitle: "产品列表",
                data: {},
                descriptions: [],
                type: 0,
                requiredValidation: false
            }
        },
        components: {
            Grid,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh
        },
        created: function () {
            let detailType = this.$route.query.type;
            let parentId = this.$route.query.parentId;
            let categoryId = this.$route.query.categoryId;
            let skuId = this.$route.query.skuId;
            if(detailType == "main"){
                this.type = 0;
            }else{
                this.type = 1;
                this.detailTitle = "配件详情";
                this.backTitle = "配件列表";
            }
            this.getSkuInitInfo(detailType, parentId, categoryId, skuId);
        },
        methods: {
            async getSkuInitInfo(type, parentId, categoryId, skuId) {
                let resp = await dealerOrderService.getSkuInitInfo(type, parentId, categoryId, skuId);
                if (resp.data.Status === "1"){
                    this.descriptions = resp.data.Data.descriptions;
                    this.data = resp.data.Data.data;
                    this.descriptions.forEach(item => {
                        if(item.required){
                            this.requiredValidation = true;
                        }
                    });
                }
            },
            async save(){
                Toast.loading({
                    duration:0,
                    message: '保存中...',
                    forbidClick: true,
                });
                let detailName = this.type == 0 ? "产品"  : "配件";
                if(this.requiredValidation){
                    let isValidationPass = true;
                    this.descriptions.forEach(item => {
                        if(item.required && !this.data[item.fieldName]){
                            Toast.clear();
                            Toast.fail(detailName + item.fieldShowName + "未"+ (item.inputType === 6 || item.inputType === 8? "选择" : "填写") +"！");
                            isValidationPass = false;
                        }
                    });
                    if(!isValidationPass){
                        return;
                    }
                }else{
                    if(!this.data.radCategory){
                        Toast.clear();
                        Toast.fail(detailName + "系列未选择！");
                        return;
                    }
                    if(!this.data.radId){
                        Toast.clear();
                        Toast.fail(detailName + "型号未选择！");
                        return;
                    }
                    if(this.type == 1){
                        if(!this.data.skuId){
                            Toast.clear();
                            Toast.fail(detailName + "规格未选择！");
                            return;
                        }
                    }
                    if(this.type == 0){
                        if(!this.data.pieces){
                            Toast.clear();
                            Toast.fail(detailName + "片数未填写！");
                            return;
                        }
                        if(!this.data.centerCategory){
                            Toast.clear();
                            Toast.fail(detailName + "高度分类未选择！");
                            return;
                        }
                        if(!this.data.centerSpacing && !this.data.heightId){
                            Toast.clear();
                            Toast.fail(detailName + "自定义高度和选择高度至少填写一个！");
                            return;
                        }else if(this.data.centerSpacing && this.data.heightId){
                            Toast.clear();
                            Toast.fail(detailName + "自定义高度和选择高度只能填写一个！");
                            return;
                        }else{
                            if(this.data.centerSpacing){
                                if(this.data.categoryType=="2a358e87230949a58d29fc796be692ce"){
                                    if(this.data.centerSpacing.indexOf("*")>-1){
                                        Toast.clear();
                                        Toast.fail(detailName + "自定义高度格式不正确！");
                                        return;
                                    }
                                    if(parseInt(this.data.centerSpacing)<300 || parseInt(this.data.centerSpacing)>1800){
                                        Toast.clear();
                                        Toast.fail(detailName +"自定义高度超出范围！");
                                        return;
                                    }
                                }
                                if(this.data.categoryType=="3a358e87230949a58d29fc796be692ce"){
                                    if(this.data.centerSpacing.indexOf("*")==-1){
                                        Toast.clear();
                                        Toast.fail(detailName + "自定义高度格式不正确！");
                                        return;
                                    }
                                    let typeHeight=this.data.centerSpacing.split("*")[0];
                                    if(parseInt(typeHeight)>1800){
                                        Toast.clear();
                                        Toast.fail(detailName +"自定义高度超出范围！");
                                        return;
                                    }
                                }
                            }
                        }
                        if(!this.data.caliber){
                            Toast.clear();
                            Toast.fail(detailName + "接口口径未选择！");
                            return;
                        }
                        if(!this.data.color){
                            Toast.clear();
                            Toast.fail(detailName + "颜色未选择！");
                            return;
                        }
                        if(!this.data.waterFlow){
                            Toast.clear();
                            Toast.fail(detailName + "进水方式未选择！");
                            return;
                        }
                    }
                }

                let resp = await dealerOrderService.saveSkuInfo(this.data);
                if (resp.data.Status === "1"){
                    Toast.clear();
                    Toast.success('保存成功！');
                    this.$router.push("skuCart");
                } else {
                    Toast.clear();
                    Toast.fail(resp.data.Message);
                }
            },
            onClickLeft(){
                this.$router.push({path:"orderSku",  query:{type: this.type}} );
            },
        },
        watch: {
            async data(){
                if(this.data.centerSpacing){
                    this.descriptions.forEach(item=>{
                        if(item.fieldName == "heightId"){
                            item.readOnly=true;
                        }
                    });
                }else{
                    this.descriptions.forEach(item=>{
                        if(item.fieldName == "heightId"){
                            item.readOnly=false;
                        }
                    });
                }
                if(this.data.heightId){
                    this.descriptions.forEach(item=>{
                        if(item.fieldName == "centerSpacing"){
                            item.readOnly=true;
                        }
                    });
                }else{
                    this.descriptions.forEach(item=>{
                        if(item.fieldName == "centerSpacing"){
                            item.readOnly=false;
                        }
                    });
                }
                if(this.data.skuId && this.data.skuId!="0"){
                    let resp = await dealerOrderService.getPsiSkuById(this.data.skuId);
                    if (resp.data.Status === "1") {
                        this.data["skuUnit"] = resp.data.Data.unit;
                        this.data["partsModel"] = resp.data.Data.specs || "";
                        this.data["partsColor"] = resp.data.Data.custom_text_01 || "";
                        this.data["partsSize"] = resp.data.Data.custom_text_02 || "";
                        Vue.set(this.data);
                    }
                }
            }
        }
    };
</script>

<style>
    .search-box {
        margin-top: 0;
    }
    .listBox{
        width: 100%;
        margin-top: 0;
    }
    .card p {
        margin:10px 0;
    }
    .card p>span:first-child {
        flex: 0 0 4rem;
        text-align: right;
        margin-right: 20px;
    }
    .van-pull-refresh__head{
        display: none;
    }
    .recordBox {
        padding: 0.5rem 0;
        box-sizing: border-box;
        margin-top: 2rem;
        bottom:0;
        position:fixed;
        width: 100%;
    }
    .skuDetailDiv{
        width:100%;
        margin:0 auto;
        overflow: hidden;
        padding-bottom: 150px;
    }
</style>